import {
  Box,
  DropdownOptions,
  FilterProvider,
  ModalProvider,
  PaginationProvider,
  SearchProvider,
  TooltipPopup,
  UpgradeSubscriptionModalType,
} from "dash-ui";

import AddPropertyToPortfolioModal from "containers/portfolio/AddPorpertyToPortfolioModal/AddPropertyToPortfolioModal";
import UpgradeSubscriptionModal from "common/components/UpgradeSubscriptionModal/UpgradeSubscriptionModal";

import TrackingPageHeader from "pages/TrackingPage/components/TrackingPageHeader/TrackingPageHeader";
import TrackingPropertiesList from "pages/TrackingPage/components/TrackingPropertiesList/TrackingPropertiesList";
import { SubscriptionChangeConfirmationModal } from "pages/ProfilePage/components/ProfileBilling/components";

const TrackingPage = () => (
  <PaginationProvider perPage={12}>
    <FilterProvider>
      <SearchProvider>
        <ModalProvider>
          <Box w="100%">
            <DropdownOptions />
            <TooltipPopup />
            <TrackingPageHeader />
            <TrackingPropertiesList />
            <AddPropertyToPortfolioModal />
            <SubscriptionChangeConfirmationModal />
            <UpgradeSubscriptionModal
              type={UpgradeSubscriptionModalType.PORTFOLIO}
            />
          </Box>
        </ModalProvider>
      </SearchProvider>
    </FilterProvider>
  </PaginationProvider>
);

export default TrackingPage;
